import { render, staticRenderFns } from "./addTPJ.vue?vue&type=template&id=9a88e1f6"
import script from "./addTPJ.vue?vue&type=script&lang=js"
export * from "./addTPJ.vue?vue&type=script&lang=js"
import style0 from "./addTPJ.vue?vue&type=style&index=0&id=9a88e1f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports